import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.warn = () => null;
console.error = () => null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
